// Components
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import Button from '../Button/Button';
import PlaybookCard from '../PlaybookCard/PlaybookCard';
import { RENDER_DOCUMENT_OPTIONS } from '../../helpers/contentful';

const PlaybooksHighlight = (props) => {
  const { title, description, list, button } = props;
  return (
    <div className="PlaybooksHighlight">
      <div className="PlaybooksHighlight-inner">
        <div className="PlaybooksHighlight-header">
          {title && (
            <h2 className="PlaybooksHighlight-title">{documentToReactComponents(title, RENDER_DOCUMENT_OPTIONS)}</h2>
          )}
          {description && <p className="PlaybooksHighlight-description">{description}</p>}
        </div>
        <div className="PlaybooksHighlight-content">
          {list && (
            <div className="PlaybooksHighlight-grid">
              {list.map((playbook, index) => (
                <div className="PlaybooksHighlight-card" key={`PlaybookCard-${index}`}>
                  <PlaybookCard {...playbook} />
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="PlaybooksHighlight-footer">
          {button && <Button label={button.label} url={button.url} modifier={button.modifier} />}
        </div>
      </div>
    </div>
  );
};

export default PlaybooksHighlight;
